module.exports = __webpack_public_path__ + "static/img/nexmo-logo-w-vonage.53180f77.png";